/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/ 
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../spinnerComponent/spinner.component.ngfactory";
import * as i3 from "../spinnerComponent/spinner.component";
import * as i4 from "../service/bHTTPLoader";
import * as i5 from "./layout.component";
import * as i6 from "../service/notification.service";
var styles_LayoutComponent = [];
var RenderType_LayoutComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_LayoutComponent, data: {} });
export { RenderType_LayoutComponent as RenderType_LayoutComponent };
export function View_LayoutComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i0.ɵdid(1, 212992, null, 0, i1.RouterOutlet, [i1.ChildrenOutletContexts, i0.ViewContainerRef, i0.ComponentFactoryResolver, [8, null], i0.ChangeDetectorRef], null, null), (_l()(), i0.ɵeld(2, 0, null, null, 1, "bh-spinner", [], null, null, null, i2.View_spinnerComponent_0, i2.RenderType_spinnerComponent)), i0.ɵdid(3, 49152, null, 0, i3.spinnerComponent, [i4.BHTTPLoader], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_LayoutComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-root", [], null, null, null, View_LayoutComponent_0, RenderType_LayoutComponent)), i0.ɵdid(1, 114688, null, 0, i5.LayoutComponent, [i6.NotificationService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var LayoutComponentNgFactory = i0.ɵccf("app-root", i5.LayoutComponent, View_LayoutComponent_Host_0, {}, {}, []);
export { LayoutComponentNgFactory as LayoutComponentNgFactory };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/layout/layout.component.ngfactory.js.pre-build-optimizer.js